import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { SourceBadge } from "@/components/SourceBadge";

const RANK_COLOR = ["#3B82F6", "#10B981", "#EF4444"];

function Item({ idx, label, item }) {
  const [open, setOpen] = useState(idx === 0);
  const color = RANK_COLOR[idx] || "#64748B";
  const weight = item.weight != null ? Math.round(item.weight) : null;
  return (
    <div className="border-b border-[#222733] py-3 last:border-0" data-testid={`macro-driver-${idx}`}>
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center gap-2 text-left">
        <span className="text-[11px] font-bold uppercase tracking-wider" style={{ color }}>{label} {idx + 1}</span>
        <span className="flex-1 truncate text-sm font-semibold text-slate-100">{item.title}</span>
        {weight != null && <span className="font-mono text-sm font-bold" style={{ color }}>{weight}%</span>}
        <ChevronDown className={`h-4 w-4 shrink-0 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && item.description && (
        <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.description}</p>
      )}
      {weight != null && (
        <div className="mt-2.5 h-2 w-full overflow-hidden rounded-full bg-[#161A22]">
          <div className="h-full rounded-full transition-all" style={{ width: `${weight}%`, background: color }} />
        </div>
      )}
    </div>
  );
}

export function MacroDrivers({ status, drivers, source }) {
  const { t } = useLang();
  return (
    <div className="rounded-lg border border-[#222733] bg-[#0E1118] p-4 sm:p-5" data-testid="macro-drivers">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-heading text-xs font-bold uppercase tracking-wider text-slate-400">{t("c.driverTitle")}</h3>
        <SourceBadge source={source === "ai" ? "fallback" : source} />
      </div>
      {status === "loading" || status === "generating" ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-16 animate-pulse rounded bg-slate-800/40" />)}</div>
      ) : !drivers || !drivers.length ? (
        <p className="text-sm text-slate-500">{t("c.driversNone")}</p>
      ) : (
        drivers.map((d, i) => <Item key={i} idx={i} label={t("c.driver")} item={d} />)
      )}
    </div>
  );
}
